import Layout from "@/views/layout/Layout.vue";
const module_data_output = [
  {
    path: "/data-output",
    component: Layout,
    children: [
      {
        path: "ScreenConfiguration",
        name: "ScreenConfiguration",
        component: () => import("@/views/data-output/ScreenConfiguration/index"),
        meta: {
          title: "大屏配置",
          needLogin: true
        }
      },
      {
        path: "BigScreenData",
        name: "BigScreenData",
        component: () => import("@/views/data-output/ScreenConfiguration/BigScreenData"),
        meta: {
          title: "大屏配置详情",
          needLogin: true
        }
      },
      {
        path: "Announcements",
        name: "Announcements",
        component: () => import("@/views/data-output/Announcements/index"),
        meta: {
          title: "公告管理",
          needLogin: true
        }
      },
      {
        path: "AnnouncementsData",
        name: "AnnouncementsData",
        component: () => import("@/views/data-output/Announcements/AnnouncementsData"),
        meta: {
          title: "公告管理详情",
          needLogin: true
        }
      },
      {
        path: "MassSMS",
        name: "MassSMS",
        component: () => import("@/views/data-output/MassSMS/index"),
        meta: {
          title: "短信群发",
          needLogin: true
        }
      },
      {
        path: "MassSMSData",
        name: "MassSMSData",
        component: () => import("@/views/data-output/MassSMS/MassSMSData"),
        meta: {
          title: "短信群发详情",
          needLogin: true
        }
      },
      // 1.6 2020-10-26
      {
        path: "informationPush",
        name: "informationPush",
        component: () => import("@/views/data-output/informationPush/index"),
        meta: {
          title: "信息推送",
          needLogin: true
        }
      },
      {
        path: "fieldConfiguration",
        name: "fieldConfiguration",
        component: () => import("@/views/data-output/fieldConfiguration/index"),
        meta: {
          title: "字段配置",
          needLogin: true
        }
      },

      {
        path: "consultation",
        name: "consultation",
        component: () => import("@/views/data-output/consultation/index"),
        meta: {
          title: "安全咨询",
          needLogin: true
        }
      },
      {
        path: "add_consultation",
        name: "add_consultation",
        component: () => import("@/views/data-output/consultation/add"),
        meta: {
          title: "回复咨询",
          needLogin: true
        }
      },
      {
        path: "fileManagement",
        name: "fileManagement",
        component: () => import("@/views/data-output/fileManagement/index"),
        meta: {
          title: "文件管理",
          needLogin: true
        }
      },
      {
        path: "questionManagement",
        name: "questionManagement",
        component: () => import("@/views/data-output/questionManagement/index"),
        meta: {
          title: "问答管理",
          needLogin: true
        }
      },
    ]
  }
];
export default module_data_output;
